/* femminile — theme scripts (no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const F = window.femminile || {};

  /* ---------- money ---------- */
  function formatMoney(cents, format = F.moneyFormat || '{{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = (n, d = 2, t = ',', dec = '.') => {
      if (isNaN(n) || n == null) return 0;
      const s = (n / 100).toFixed(d).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (s[1] ? dec + s[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(cents, 2),
      amount_no_decimals: fmt(cents, 0),
      amount_with_comma_separator: fmt(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_apostrophe_separator: fmt(cents, 2, "'", '.'),
    }[k] ?? fmt(cents, 2)));
  }
  F.formatMoney = formatMoney;

  /* ---------- header ---------- */
  const header = $('.header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- generic open/close panels ---------- */
  const lock = (on) => { document.documentElement.style.overflow = on ? 'hidden' : ''; };
  function openPanel(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true); }
  function closePanel(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lock(false); }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      const target = $(opener.dataset.open);
      openPanel(target);
      const focusEl = target && $('input[type=search], input[type=text]', target);
      if (focusEl) setTimeout(() => focusEl.focus(), 60);
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closePanel(closer.closest('.is-open')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.is-open').forEach(closePanel);
  });

  /* ---------- announcement rotator ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  });

  /* ---------- sliders ---------- */
  $$('[data-slider-wrap]').forEach((wrap) => {
    const track = $('.slider', wrap);
    if (!track) return;
    const step = () => (track.firstElementChild?.getBoundingClientRect().width || 300) + 20;
    $('[data-prev]', wrap)?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-next]', wrap)?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- wishlist (per browser) ---------- */
  const WKEY = 'femminile:wishlist';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch { return []; } };
  const writeWish = (l) => { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch {} };
  const paintWish = () => {
    const list = readWish();
    $$('[data-wish]').forEach((b) => b.classList.toggle('is-on', list.includes(b.dataset.wish)));
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    const list = readWish();
    const h = b.dataset.wish;
    writeWish(list.includes(h) ? list.filter((x) => x !== h) : [...list, h]);
    paintWish();
  });
  paintWish();

  /* ---------- cart ---------- */
  const drawer = $('#CartDrawer');
  const fetchJSON = (url, opts = {}) => fetch(url, { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...opts }).then((r) => r.json().then((d) => (r.ok ? d : Promise.reject(d))));

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count > 0 ? count : ''; });
  }

  function escapeHTML(s) { return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;
    const threshold = Number(drawer.dataset.threshold || 0) * 100;
    const shipBar = $('[data-ship-bar]', drawer);
    if (shipBar) {
      if (threshold > 0 && cart.item_count > 0) {
        shipBar.hidden = false;
        const left = threshold - cart.total_price;
        const pct = Math.min(100, (cart.total_price / threshold) * 100);
        $('[data-ship-text]', shipBar).innerHTML = left > 0
          ? `You're <strong>${formatMoney(left)}</strong> away from free shipping ♡`
          : 'Yay! Your order ships <strong>free</strong> ♡';
        $('.ship-bar__fill', shipBar).style.width = pct + '%';
      } else shipBar.hidden = true;
    }
    $$('[data-cart-count-label]', drawer).forEach((el) => { el.textContent = cart.item_count; });
    const body = $('[data-drawer-body]', drawer);
    const foot = $('[data-drawer-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = $('#CartEmptyTpl').innerHTML;
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    $('[data-cart-total]', drawer).textContent = formatMoney(cart.total_price);
    body.innerHTML = cart.items.map((it, idx) => `
      <div class="line" data-line="${idx + 1}">
        <a class="line__img" href="${it.url}">${it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=200" alt="${escapeHTML(it.product_title)}" loading="lazy" width="84" height="105">` : ''}</a>
        <div class="line__info">
          <a class="line__title" href="${it.url}">${escapeHTML(it.product_title)}</a>
          ${it.product_has_only_default_variant ? '' : `<span class="line__variant">${escapeHTML(it.variant_title)}</span>`}
          <span class="price">${it.original_line_price !== it.final_line_price ? `<s class="price__compare">${formatMoney(it.original_line_price)}</s>` : ''}<span>${formatMoney(it.final_line_price)}</span></span>
          <div class="line__row">
            <div class="qty">
              <button type="button" data-qty-line="${idx + 1}" data-qty="${it.quantity - 1}" aria-label="Decrease">−</button>
              <input type="number" value="${it.quantity}" min="0" aria-label="Quantity" readonly>
              <button type="button" data-qty-line="${idx + 1}" data-qty="${it.quantity + 1}" aria-label="Increase">+</button>
            </div>
            <button type="button" class="line__remove" data-qty-line="${idx + 1}" data-qty="0">Remove</button>
          </div>
        </div>
      </div>`).join('');
  }
  F.renderCart = renderCart;

  async function refreshCart(open = false) {
    const cart = await fetchJSON('/cart.js');
    renderCart(cart);
    if (open && F.cartDrawer && drawer) openPanel(drawer);
    return cart;
  }

  async function addToCart(items, btn) {
    btn && btn.classList.add('is-loading');
    try {
      await fetchJSON(F.routes.cart_add + '.js', { method: 'POST', body: JSON.stringify({ items }) });
      if (F.cartDrawer && drawer) await refreshCart(true);
      else window.location.href = F.routes.cart;
    } catch (err) {
      alert(err?.description || err?.message || 'Sorry, this item could not be added.');
    } finally {
      btn && btn.classList.remove('is-loading');
    }
  }
  F.addToCart = addToCart;

  // product forms
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !F.cartDrawer) return;
    e.preventDefault();
    const fd = new FormData(form);
    addToCart([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], form.querySelector('[type=submit]'));
  });

  // quick add size buttons on cards
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    addToCart([{ id: Number(b.dataset.quickAdd), quantity: 1 }], b.closest('.card'));
  });

  // line quantity changes (drawer + cart page)
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty-line]');
    if (!b) return;
    e.preventDefault();
    const scope = b.closest('.line');
    scope && scope.classList.add('is-loading');
    try {
      const cart = await fetchJSON(F.routes.cart_change + '.js', { method: 'POST', body: JSON.stringify({ line: Number(b.dataset.qtyLine), quantity: Math.max(0, Number(b.dataset.qty)) }) });
      if (b.closest('[data-cart-page]')) { window.location.reload(); return; }
      renderCart(cart);
    } catch (err) {
      alert(err?.description || 'Could not update the cart.');
      scope && scope.classList.remove('is-loading');
    }
  });

  // open the cart drawer instead of navigating
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-cart-toggle]');
    if (!a || !F.cartDrawer || !drawer) return;
    e.preventDefault();
    refreshCart(true);
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('script[data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name=id]', form);
    const btn = $('[data-atc]', root);
    const btnLabel = $('[data-atc-label]', root);
    const priceEl = $('[data-price]', root);
    const saveEl = $('[data-save]', root);
    const gallery = $('[data-gallery]', root);
    const sticky = $('[data-sticky-atc]');

    const selected = () => $$('fieldset[data-option]', root).map((fs) => $('input:checked', fs)?.value);

    function markAvailability(sel) {
      $$('fieldset[data-option]', root).forEach((fs, pos) => {
        $$('input', fs).forEach((inp) => {
          const test = [...sel]; test[pos] = inp.value;
          const ok = variants.some((v) => v.options.every((o, i) => o === test[i]) && v.available);
          inp.classList.toggle('is-unavailable', !ok);
        });
        const label = $('[data-option-value]', fs);
        if (label) label.textContent = sel[pos] || '';
      });
    }

    function update() {
      const sel = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      markAvailability(sel);
      if (!v) {
        btn.disabled = true; btnLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btnLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      const onSale = v.compare_at_price > v.price;
      priceEl.innerHTML = `<span class="price ${onSale ? 'price--sale' : ''}">${onSale ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s>` : ''}<span class="price__current">${formatMoney(v.price)}</span></span>`;
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) saveEl.textContent = `Save ${Math.round((1 - v.price / v.compare_at_price) * 100)}%`;
      }
      if (sticky) {
        $('[data-sticky-price]', sticky).textContent = formatMoney(v.price);
        $('button', sticky).disabled = !v.available;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      if (v.featured_media && gallery) {
        const m = $(`[data-media-id="${v.featured_media}"]`, gallery);
        if (m) {
          if (window.innerWidth <= 860) gallery.scrollTo({ left: m.offsetLeft, behavior: 'smooth' });
          else if (m !== gallery.firstElementChild) gallery.prepend(m);
        }
      }
    }
    root.addEventListener('change', (e) => { if (e.target.closest('fieldset[data-option]')) update(); });
    update();

    // qty stepper
    $$('[data-step]', root).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name=quantity]', root);
      input.value = Math.max(1, Number(input.value) + Number(b.dataset.step));
    }));

    // mobile gallery dots
    const dots = $$('.pdp__dots span', root);
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      }, { passive: true });
    }

    // sticky add to cart
    if (sticky && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(btn);
      $('button', sticky).addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }
  });

  /* ---------- collection filters ---------- */
  $$('[data-filter-form]').forEach((form) => {
    let t;
    form.addEventListener('change', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const params = new URLSearchParams(new FormData(form));
        for (const [k, v] of [...params]) if (v === '') params.delete(k);
        window.location.search = params.toString();
      }, 350);
    });
  });
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url;
  }));
  $$('[data-toggle-filters]').forEach((b) => b.addEventListener('click', () => {
    const layout = $('.collection-layout');
    if (window.innerWidth <= 860) layout.classList.toggle('is-open');
    else layout.classList.toggle('is-collapsed');
  }));
})();
